import { FormField, FormItem, FormControl } from "@/components/ui/form";
import { Switch } from "@/components/ui/switch";
import { UseFormReturn } from "react-hook-form";
import { ProviderFormData } from "../ProviderForm";

interface ToggleFieldProps {
  form: UseFormReturn<ProviderFormData>;
  name: "is_active" | "certified";
  label: string;
  description: string;
}

export function ToggleField({
  form,
  name,
  label,
  description,
}: ToggleFieldProps) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem className="flex flex-row items-center justify-between rounded-lg border p-4">
          <div className="space-y-0.5">
            <div className="text-base">{label}</div>
            <div className="text-sm text-muted-foreground">
              {description}
            </div>
          </div>
          <FormControl>
            <Switch
              checked={field.value}
              onCheckedChange={field.onChange}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
}